// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins.js"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins.js"

//Service
import puppySellService from "@/app/services/main/puppy-sell/puppy-sell-service.js"

// Constants
import { STATUS_CODES, PUPPY_SELL_STATUS } from "@/app/constants/constants"

export default {
    name: "PuppySellingListContainer",
    mixins: [tableMixins, toastMessageMixins],
    data() {
        return {
            isAPILoading: true,
            tabs: [
                {
                    id: 'puppy',
                    label: 'Puppies for Sale',
                    active: true
                }
            ],
            // table
            theads: [
                {
                    name: "SKU",
                    searchLabel: "f_sku",
                    sortLabel: "sku",
                    isDesc: false,
                    hasSearch: true,
                    style: "width: 200px;",
                },
                {
                    name: "Reference Number",
                    searchLabel: "f_referenceNumber",
                    sortLabel: "referenceNumber",
                    isDesc: false,
                    hasSearch: true,
                    style: "width: 200px;",
                },
                {
                    name: "Company Name",
                    searchLabel: "f_companyName",
                    sortLabel: "companyName",
                    isDesc: false,
                    hasSearch: true,
                    style: "width: 200px",
                },
                {
                    name: "Image",
                    searchLabel: null,
                    sortLabel: null,
                    isDesc: false,
                    hasSearch: false,
                    style: "max-width: 150px;",
                },
                {
                    name: "Breeder Name",
                    searchLabel: "f_breederName",
                    sortLabel: "breederName",
                    isDesc: false,
                    hasSearch: true,
                    style: "width: 200px;",
                },
                { 
                    name: 'Customer Name', 
                    searchLabel: 'f_customerName', 
                    sortLabel: 'customerName', 
                    isDesc: false, 
                    hasSearch: true, 
                    style: "width: 200px;",
                 },
                {
                    name: "Breed",
                    searchLabel: "f_breedName",
                    sortLabel: "breedName",
                    isDesc: false,
                    hasSearch: false,
                    style: null,
                },
                {
                    name: "Status",
                    searchLabel: "f_status",
                    sortLabel: "status",
                    isDesc: false,
                    hasStatusSearch: true,
                    style: "min-width: 100px",
                },
                {
                    name: null,
                    searchLabel: null,
                    sortLabel: null,
                    isDesc: false,
                    hasSearch: false,
                    style: "width: 170px",
                },
            ],
            statusList: [
                { id: "AVAILABLE", name: "AVAILABLE" },
                { id: "PENDING", name: "PENDING" },
                { id: "SOLD", name: "SOLD" },
                { id: "REQUEST_REFUND", name: "REQUEST FOR REFUND" },
                { id: "REFUNDED", name: "REFUNDED" },
                { id: "PICKED_UP", name: "PICKED UP" },
                { id: "PENDING_PAYMENT", name: "PENDING PAYMENT" },
                { id: "HIDDEN", name: "HIDDEN" },
            ],
            // sorting
            desc: true,
        }
    },
    computed: {
        getActiveTab() {
            return this.tabs.find(tab => tab.active);
        },
        dogPurchasePendingRequest() {
            return this.$store.getters.getdogPurchasePendingRequestCount;
        },
        pendingPuppySellCount() {
            return this.$store.getters.getPendingPuppySellCount;
        }
    },
    watch: {},
    created() {
        this.getTableContent()
    },
    activated() {
        // this lifecycle method will only be called for components under keep-alive
        this.getTableContent();
	},
    methods: {
        setActiveTab(id) {
            if ( id === "dog" ) {
                this.$router.replace('/pet-purchases/puppy-selling');
            }
        },
        getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
            page = fromFilter ? 1 : this.page
            this.getPuppySellList({ page, limit, sortBy, desc })
        },
        getPuppySellList(queryParams) {
            // search filters
            if (this.columnsFilter) {
                const { f_breederId, f_breederName, f_breedName, f_status, f_referenceNumber, f_sku, f_customerName, f_companyName } =
                    this.columnsFilter
                
                    
                if (f_companyName) {
                    queryParams["f_companyName"] = f_companyName
                }
                    
                if (f_customerName) {
                    queryParams["f_customerName"] = f_customerName
                }

                if (f_breederId) {
                    queryParams["f_breederId"] = f_breederId
                }

                if (f_breederName) {
                    queryParams["f_breederName"] = f_breederName
                }

                if (f_breedName) {
                    queryParams["f_breedName"] = f_breedName
                }

                if (f_status) {
                    queryParams["f_status"] = f_status
                }
                if (f_referenceNumber) {
                    queryParams["f_referenceNumber"] = f_referenceNumber
                }
                if (f_sku) {
                    queryParams["f_sku"] = f_sku
                }
            }

            this.isAPILoading = true

            puppySellService.getPuppySellList(queryParams).then((res) => {
                if (res.status === STATUS_CODES.SUCCESS) {
                    this.tableContent = {
                        tableData: res.data.data
                            .map((dt) => {
                                return { ...dt, status: PUPPY_SELL_STATUS[dt.status] === 'HIDE' ? dt.status : PUPPY_SELL_STATUS[dt.status] }
                            })
                            .filter((dt) => dt.status != "DECLINED"),
                        paginationData: res.data.pagination,
                    }

                    this.isAPILoading = false
                } else {
                    this.showAPIErrorToast("Unable to fetch puppy sell list.", res)
                    this.isAPILoading = false
                }
            })
        },
        hasProductImage(productImage) {
            let image = require("@/assets/images/temporary/product-image.png")

            if (productImage) {
                image = productImage
            }

            return image
        },
        updatePuppySellStatus(puppySellId, status, buyerId) {

            this.$swal({
                titleText: `Mark Puppy as ${PUPPY_SELL_STATUS[status]}`,
                html: `<p style='color: #ff801e; margin: .75rem 0 .25rem 0;'>Are you sure you want to update the puppy status to <strong style='color: #ff801e'>${PUPPY_SELL_STATUS[status]}</strong>?</p>`,
                confirmButtonText: "Confirm",
                showCancelButton: true,
                cancelButtonText: "Cancel",
                reverseButtons: true,
                showCloseButton: true
            }).then((result) => {
                if (result.value) {
                    this.isAPILoading = true
                    const details = {
                        status,
                        buyerId
                    }
                    puppySellService.updatePuppyDetailsStatus(puppySellId, details).then((response) => {
                        if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                            this.getTableContent()
                            this.showCustomSuccessToast(
                                `Successfully updated Puppy selling status to ${PUPPY_SELL_STATUS[status]}`
                            )
                        } else {
                            this.showAPIErrorToast(errorMessage, response)
                        }
                        this.isAPILoading = false
                    })
                }
            })
        },
    },
    // third party libraries
}